import Env from "@/constants/environment"
import * as Sentry from "@sentry/vue"

export const logger = {
  /**
   * Report a handled error or exception with the current user and additional context
   * @param err error message as a string or any Error or non-Error object
   * @param context Additional context to be passed to the reporter
   */
  report(err: unknown, context: Record<string, unknown> = {}): void {
    if (Env.isDevelopment) {
      console.error(err)
    }

    Sentry.captureException(err, { extra: context })
  },
}

export default logger
